﻿import Swiper from "swiper";
import {Navigation, Thumbs} from 'swiper/modules';
import initProductImageZoom from "./productZoom";

const productPageSlider = {
    mainSlider: undefined,
    thumbSlider: undefined,
    assets: undefined,
    currentSelectedAssets: undefined,
    zoom: undefined,
    setAssets(assets) {
        this.assets = assets;
    },
    addAssets(assets) {
        for (const [key, value] of Object.entries(assets)) {
            this.assets[key] = value;
        }
    },
    getAssetsBySku(sku) {
        this.currentSelectedAssets = this.assets[sku];
        return this.currentSelectedAssets;
    },
    deleteSlider() {
        if (this.thumbSlider !== undefined) {
            this.thumbSlider.destroy(true, true);
        }
        if (this.mainSlider !== undefined) {
            this.mainSlider.destroy(true, true);
        }
    },
    resetSlider() {
        if (this.mainSlider !== undefined) {
            this.mainSlider.init();
            this.mainSlider.update();
        }
        if (this.thumbSlider !== undefined) {
            this.thumbSlider.init();
            this.thumbSlider.update();
        }
    },
    initSlider() {
        document.getElementById('preload-main-image')?.remove();
        if (this.currentSelectedAssets === undefined || Object.entries(this.currentSelectedAssets).length <= 1) {
            initProductImageZoom();
            return;
        }

        this.thumbSlider = new Swiper('.thumbs-swiper', {
            spaceBetween: 10,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,

        });


        this.mainSlider = new Swiper('.product-swiper', {
            slidesPerView: "1",
            spaceBetween: 15,

            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: this.thumbSlider
            },
            modules: [
                Navigation,
                Thumbs
            ],
            on: {
               
                afterInit: function () {
                    this.zoom = initProductImageZoom();
                },
                slideChangeTransitionStart: function () {
                    if (this.zoom) {
                        this.zoom.kill();
                    }
                    this.zoom = initProductImageZoom(this.slides[this.activeIndex].getElementsByTagName('img')[0]);
                    
                    for (let i = 0; i < this.slides.length; i++) {
                        let videos = this.slides[i].getElementsByTagName('video');
                        for (let j = 0; j < videos.length; j++) {
                           videos[j].pause();
                        }
                    }
                }
            }
        });
    },
};

window.productPageSlider = productPageSlider;